<template>
  <div id="carousel" class="carousel-container">
    <div class="carousel-inner">
      <div
        v-for="(slide, index) in slides"
        :key="index"
        class="carousel-item"
        :class="{ active: index === currentSlide }"
      >
        <!-- Se for imagem -->
        <template v-if="slide.type === 'image'">
          <img class="media-content" :src="slide.src" :alt="slide.alt">
        </template>

        <!-- Se for vídeo local -->
        <template v-else-if="slide.type === 'video' && !slide.youtube">
          <video
            class="media-content"
            :src="slide.src"
            ref="videos"
            controls
            @click.stop
            @loadedmetadata="setVideoDuration(index)"
            @ended="nextSlide"
          ></video>
        </template>

        <!-- Se for vídeo do YouTube -->
        <template v-else-if="slide.type === 'video' && slide.youtube">
          <iframe
            class="media-content"
            :src="getYouTubeEmbedUrl(slide.src)"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </template>

        <!-- Se for link externo ou iframe -->
        <template v-else-if="slide.type === 'iframe'">
          <iframe
            class="media-content"
            :src="slide.src"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </template>
      </div>
    </div>
    <button v-if="showControls" class="carousel-control-prev" @click="prevSlide">&#10094;</button>
    <button v-if="showControls" class="carousel-control-next" @click="nextSlide">&#10095;</button>
  </div>
</template>

<script>
export default {
  props: {
    slides: {
      type: Array,
      required: true
    },
    showControls: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentSlide: 0,
      interval: null
    }
  },
  methods: {
    nextSlide () {
      this.pauseCurrentVideo()
      this.currentSlide = (this.currentSlide + 1) % this.slides.length
      this.startAutoPlay()
    },
    prevSlide () {
      this.pauseCurrentVideo()
      this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length
      this.startAutoPlay()
    },
    startAutoPlay () {
      this.stopAutoPlay()
      const current = this.slides[this.currentSlide]

      if (current.type === 'video' && !current.youtube && this.$refs.videos && this.$refs.videos[this.currentSlide]) {
        const video = this.$refs.videos[this.currentSlide]
        video.play()
        video.onended = () => this.nextSlide()
      } else {
        this.interval = setTimeout(this.nextSlide, 5000)
      }
    },
    stopAutoPlay () {
      clearTimeout(this.interval)
    },
    pauseCurrentVideo () {
      if (this.$refs.videos && this.$refs.videos[this.currentSlide]) {
        this.$refs.videos[this.currentSlide].pause()
      }
    },
    setVideoDuration (index) {
      if (this.$refs.videos && this.$refs.videos[index]) {
        const video = this.$refs.videos[index]
        this.stopAutoPlay()
        setTimeout(this.nextSlide, video.duration * 1000)
      }
    },
    getYouTubeEmbedUrl (url) {
      const parts = url.split('v=')
      if (parts.length > 1) {
        const videoId = parts[1].split('&')[0]
        return `https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=1&mute=0&loop=1&playlist=${videoId}&controls=1&modestbranding=1&rel=0`
      }
      return ''
    }
  },
  mounted () {
    this.startAutoPlay()
  },
  beforeDestroy () {
    this.stopAutoPlay()
  }
}
</script>

<style scoped>
.carousel-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-inner {
  width: 100%;
  height: 100%;
  display: flex;
}

.carousel-item {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-fluid, .video-fluid, .youtube-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-item.active {
  display: block;
}

.media-content {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: none;
}

.carousel-control-prev, .carousel-control-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 15px;
  cursor: pointer;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.carousel-control-prev {
  left: 10px;
}

.carousel-control-next {
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/nxSenhas/tv/components/Carousel.vue